@if (isLoading$ | async) {
  <app-loading />
}

<div class="notifications" #notificationsContainer></div>

<app-header />
<main>
  <router-outlet></router-outlet>
</main>
<app-footer />
